// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"tW-z","dimensionLabel":"uW-z","styleChooserControlWrapper":"vW-z","styleChooserControl":"wW-z","disabled":"xW-z","giftCard":"yW-z","styleChooserText":"zW-z"};